import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tMedicineModel,tMedicineModelPage } from '../Models/tMedicineModel';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { tMediConvModel, tGRNMediConvModel, tPresMediConvModel } from '../models/tMediConvModel';
import { tMediCostModel } from '../models/tMediCostModel';
import { isNullOrUndefined } from 'util';
import { NavigationComponent } from '../pages/navigation/navigation.component';
import { tInvtModel } from '../models/tInvtModel';

//import { Update_tShopModel } from './Update_SystemShopSettingModel';



@Injectable({
    providedIn: 'root'
  })
  export class tMedicineService {

    private messageSource = new BehaviorSubject('default message');
    currentMessage = this.messageSource.asObservable();

    private readonly defaultMessage = '<未選取>';


    private selected_mediCode_Source = new BehaviorSubject(this.defaultMessage);
    current_selected_mediCode = this.selected_mediCode_Source.asObservable();

    private selected_mediCateCode_Source = new BehaviorSubject(this.defaultMessage);
    current_selected_mediCateCode = this.selected_mediCateCode_Source.asObservable();

    private selected_mediType_Source = new BehaviorSubject(this.defaultMessage);
    current_selected_mediType = this.selected_mediType_Source.asObservable();

    private selected_mediName_Source = new BehaviorSubject(this.defaultMessage);
    current_selected_mediName = this.selected_mediName_Source.asObservable();

    private selected_mediNameEng_Source = new BehaviorSubject(this.defaultMessage);
    current_selected_mediNameEng = this.selected_mediNameEng_Source.asObservable();

    private selected_mediBarCode_Source = new BehaviorSubject(this.defaultMessage);
    current_selected_mediBarCode = this.selected_mediBarCode_Source.asObservable();



    constructor(private http: HttpClient) { }

    ResetMessage() {

      let mediCodeStr = this.defaultMessage;
      let mediCateCodeStr = this.defaultMessage;
      let mediNameStr = this.defaultMessage;
      let mediNameEngStr = this.defaultMessage;
      let mediBarCodeStr = this.defaultMessage;
      let mediTypeStr = this.defaultMessage;
      this.selected_mediCode_Source.next(mediCodeStr);
      this.selected_mediCateCode_Source.next(mediCateCodeStr);
      this.selected_mediName_Source.next(mediNameStr);
      this.selected_mediNameEng_Source.next(mediNameEngStr);
      this.selected_mediBarCode_Source.next(mediBarCodeStr);
      this.selected_mediType_Source.next(mediTypeStr);
      // this.messageSource.next(message);
    }


    changeMessage(systemMedicineSetting: tMedicineModel) {

      let mediCodeStr = '';
      let mediCateCodeStr = '';
      let mediNameStr = '';
      let mediNameEngStr = '';
      let mediBarCodeStr = '';
      let mediTypeStr = '';
      if (!isNullOrUndefined(systemMedicineSetting.mediCode)) {
        mediCodeStr = systemMedicineSetting.mediCode.toString();
      }
      if (!isNullOrUndefined(systemMedicineSetting.mediCateCode)) {
        mediCateCodeStr = systemMedicineSetting.mediType.toString();
      }
      if (!isNullOrUndefined(systemMedicineSetting.mediName)) {
        mediNameStr = systemMedicineSetting.mediName.toString();
      }
      if (!isNullOrUndefined(systemMedicineSetting.mediNameEng)) {
        mediNameEngStr = systemMedicineSetting.mediNameEng.toString();
      }
      if (!isNullOrUndefined(systemMedicineSetting.mediBarCode)) {
        mediBarCodeStr = systemMedicineSetting.mediBarCode.toString();
      }
      if (!isNullOrUndefined(systemMedicineSetting.mediType)) {
        mediTypeStr = systemMedicineSetting.mediType.toString();
      }

      this.selected_mediCode_Source.next(mediCodeStr);
      this.selected_mediCateCode_Source.next(mediCateCodeStr);
      this.selected_mediName_Source.next(mediNameStr);
      this.selected_mediNameEng_Source.next(mediNameEngStr);
      this.selected_mediBarCode_Source.next(mediBarCodeStr);
      this.selected_mediType_Source.next(mediTypeStr);
      // this.messageSource.next(message);
    }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tMedicineModels';
    readonly pathNameConv = '/tMediConvModels';
    readonly pathNameCost = '/tMediCostModels';
    readonly pathNameInv = '/tInvt';

    getAllData(){
      return this.http.get<tMedicineModelPage[]>(this.baseurl + this.pathName + '/' + NavigationComponent.selectedShopID.toString());
    }

    getDataById(mediCode: string, mediCateCode: string){
      return this.http.get<tMedicineModel>(this.baseurl + this.pathName + '/' + mediCode + '/' + mediCateCode + '/'
      + NavigationComponent.selectedShopID.toString());
    }

    // getDataByMediCode(mediCode: string){
    //   return this.http.get<tMedicineModel>(this.baseurl + this.pathName + '/' + mediCode);
    // }

    getConvDataByMediCode(mediCode: string){
      return this.http.get<tMediConvModel[]>(this.baseurl + this.pathNameConv + '/' + 'getByCode' + '/' + mediCode
      + '/' + NavigationComponent.selectedShopID.toString());
    }

    getConvDataByMediCodeConv(mediCode: string){
      return this.http.get<tMediConvModel[]>(this.baseurl + this.pathNameConv + '/' + 'getByCode' + '/' + mediCode
      + '/' + NavigationComponent.selectedShopID.toString());
    }

    getCostDataByMediCode(mediCode: string){
      return this.http.get<tMediCostModel[]>(this.baseurl + this.pathNameCost + '/' + 'getByCode' + '/' + mediCode
      + '/' + NavigationComponent.selectedShopID.toString());
    }



    addData(data: tMedicineModel){
      return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data);
    }

    getExistedMediCode(mediCode: string){
      return this.http.get<tMedicineModel[]>(this.baseurl + this.pathName + '/' + 'getExistedMediCode' + '/' + mediCode
      + '/' + NavigationComponent.selectedShopID.toString());
    }

    deleteData(data: tMedicineModel){
      return this.http.delete(this.baseurl + this.pathName + '/' + 'Formatted' + '/' + data.mediCode + '/' + data.mediCateCode
      + '/' + NavigationComponent.selectedShopID.toString());
    }

    updateData(data: tMedicineModel){
      console.log();
      // data.lastModifyLoginName = "2";
      return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted' + '/' + data.mediCode + '/' + data.mediCateCode
      + '/' + NavigationComponent.selectedShopID.toString(), data);
    }

    updateConvData(data: tMediConvModel){
      console.log();
      // data.lastModifyLoginName = "2";
      return this.http.put(this.baseurl + this.pathNameConv  + '/' + 'Formatted' + '/' + data.mediCode
      + '/' + NavigationComponent.selectedShopID.toString(), data);
    }

    updateCostData(data: tMediCostModel){
      console.log();
      // data.lastModifyLoginName = "2";
      return this.http.put(this.baseurl + this.pathNameCost  + '/' + 'Formatted' + '/' + data.mediCode
      + '/' + NavigationComponent.selectedShopID.toString(), data);
    }

    getGRNConvMediCode(){
      return this.http.get<tGRNMediConvModel[]>(this.baseurl + this.pathNameConv + '/' + 'GetGRNMedicine'
      + '/' + NavigationComponent.selectedShopID.toString());
    }

    getMedicineByType(shopID: string, cateCode: number){
      return this.http.get<tPresMediConvModel[]>(this.baseurl + this.pathNameConv
        + '/' + 'GetMedicineByType' + '/' + shopID + '/' + cateCode);
    }
    getAllMedicine(shopID: string){
      return this.http.get<tPresMediConvModel[]>(this.baseurl + this.pathNameConv
        + '/' + 'GetAllMedicine' + '/' + shopID);
    }
    getLastCost(shopID: string, mediCode: string, itemType: string){
      return this.http.get<tInvtModel[]>(this.baseurl + this.pathNameInv
        + '/' + 'GetMedLastCost' + '/' + shopID + '/' + mediCode + '/' + itemType);
    }

    //for demo , not production
    getMediCosts(){
      return this.http.get<tMediCostModel[]>(this.baseurl + this.pathNameCost);
    }

  }
